<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :edit-permission="editPermission"
    allow-delete
    :show-status-column="false"
  />
</template>

<script>
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'
  import TariffDataService from '@/services/api/TariffDataService'
  import RouteName from '@/models/enums/RouteName'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'TariffList',
    components: { EntityListTable },
    data () {
      return {
        title: 'Тарифы',
        dataService: TariffDataService,
        createRouteName: RouteName.AdministrationTariffCreate,
        editRouteName: RouteName.AdministrationTariffEdit,
        // Без права правки таблица остаётся только на чтение: ни «Создать», ни действий в строках.
        editPermission: CRMPermission.ViewAdministrationTariffs,
        headers: [
          { text: 'ID', value: 'id', align: 'center' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Цена за филиал в месяц', value: 'price', align: 'center' },
          {
            text: 'Активен',
            value: 'isActive',
            align: 'center',
            type: 'boolean-check',
          },
        ],
      }
    },
  }
</script>
